<template>
  <div style="padding-left: 20px; padding-right: 20px">
    <div v-if="payAutoBilled" class="text-center pd-20">
      <h6
        class="tx-13 tx-spacing-1 tx-uppercase tx-semibold mg-b-0 text-success"
      >
        Төлбөр амжилттай төлөгдсөн
      </h6>
    </div>
    <div class="row" v-else>
      <div :class="`${!$store.state.app.isMobile?'col-sm-12 col-md-8':(isFullRow?'col-sm-12':'')}`">
        <!-- <vue-custom-scrollbar
          :style="`height: ${scrollHeight.content} !important; position: relative; `"
        > -->
        <div v-if="payCur == null">
          <h6 class="tx-13 tx-spacing-1 tx-uppercase tx-semibold mg-b-0">
            Төлбөрийн хэлбэр сонгох
          </h6>
          <div class="row payment-methods">
            <div
              @click="choosePayment(p)"
              v-for="(p, i) in payMethods"
              :key="i"
              class="col-sm-12 col-lg-6"
              role="button"
            >
              <div
                class="bg-white rounded wd-100p bd bd-2 bd-light pd-2-f"
                :class="{ 'bd-primary': payCur != null && payCur.id == p.id }"
              >
                <div class="pd-10">
                  <div class="d-flex">
                    <div class="mg-r-10">
                      <img
                        :src="
                          `https://res.gosmart.mn/media/logo/pay/${p.logo}?w=40`
                        "
                        class="wd-40"
                      />
                    </div>
                    <div class>
                      <div>{{ p.info }}</div>
                      <h6>{{ p.name }}</h6>
                    </div>
                  </div>
                </div>
                <div class="bg-light pd-10">{{ p.desc }}</div>
              </div>
            </div>
          </div>

          <slot />
        </div>
        <div v-else>
          <h6 v-show="!$store.state.app.isMobile" class="tx-13 tx-spacing-1 tx-uppercase tx-semibold mg-b-15">
            Төлбөр төлөх
          </h6>
          <div v-if="payCur.key != undefined && payCur.key == 'paymentInvoice' && !$store.state.app.isMobile">
            <!-- {{filePreview}} -->
            <!-- {{filePreview.link}} -->
            <template v-if="invoice.isHtml">
              <div>
                <div class="row">
                  <div class="col-sm-6">
                    <label
                      class=" tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
                      >Нэхэмжлэгч</label
                    >
                    <h6 class="tx-15 mg-b-10">ГӨҮСМАРТ ТМ ХХК</h6>
                    <p class="mg-b-0">
                      Хаяг: 205 тоот, МТҮП, Сүхбаатар дүүрэг, Улаанбаатар хот
                    </p>
                    <p class="mg-b-0">Утас: 77110313</p>
                    <p class="mg-b-0">И-мэйл: info@gosmart.mn</p>

                    <p class="mg-b-0">Банкны нэр: Төрийн банк</p>
                    <p class="mg-b-0">
                      Данс:
                      <input
                        class=" tx-normal tx-color-01 mg-b-10 tx-spacing--2 tx-20"
                        v-on:focus="$event.target.select()"
                        readonly
                        value="343100195073"
                        ref="accno"
                      />
                      /төгрөг/
                      <button @click="copy()" class="btn btn-xs btn-info">
                        хуулах
                      </button>
                    </p>
                  </div>
                  <!-- col -->
                  <div class="col-sm-6 tx-right d-none d-md-block">
                    <label
                      class=" tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
                      >Нэхэмжлэхийн дугаар</label
                    >
                    <h1 class="tx-normal tx-color-03 mg-b-10 tx-spacing--2">
                      {{ invoice.obj.id }}
                    </h1>
                  </div>
                  <!-- col -->
                  <div class="col-sm-6 col-lg-8 mg-t-40 mg-sm-t-0 mg-md-t-40">
                    <label
                      class=" tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
                      >Төлөгч</label
                    >
                    <h6 class="tx-15 mg-b-10">
                      {{ $store.state.user.userInfo.fullName }}
                    </h6>
                    <p class="mg-b-0">
                      Регистр: {{ $store.state.user.userInfo.register }}
                    </p>
                    <p class="mg-b-0">
                      Утас: {{ $store.state.user.userInfo.mobile }}
                    </p>
                    <!-- <p class="mg-b-0">Email: youremail@companyname.com</p> -->
                  </div>
                  <!-- col -->
                  <div class="col-sm-6 col-lg-4 mg-t-40">
                    <label
                      class=" tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
                      >Нэхэмжлэхийн дэлгэрэнгүй</label
                    >
                    <ul class="list-unstyled lh-7">
                      <li class="d-flex justify-content-between">
                        <span>{{ invoice.obj.product.task }}</span>
                        <!-- <span>{{invoice.obj.id}}</span> -->
                      </li>
                      <li class="d-flex justify-content-between">
                        <span>Нэхэмжлэхийн дугаар</span>
                        <span>{{ invoice.obj.id }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        <span>Гүйлгээний утга</span>
                        <strong>{{
                          $store.state.user.userInfo.register
                        }}</strong>
                      </li>
                      <li class="d-flex justify-content-between">
                        <span>Үүсгэсэн</span>
                        <span>{{
                          invoice.obj.task.createdDate | moment("YYYY.MM.DD")
                        }}</span>
                      </li>
                      <li class="d-flex justify-content-between">
                        <span>Төлөх дүн</span>
                        <span
                          >{{
                            invoice.obj.task.budget | formatMoney(0, ".", ",")
                          }}
                          ₮</span
                        >
                      </li>

                     
                    </ul>
                  </div>
                  <!-- col -->
                </div>
                <div class="table-responsive mg-t-40">
                  <table class="table table-invoice bd-b">
                    <thead>
                      <tr>
                        <th class="wd-20p">№</th>
                        <th class="wd-40p d-none d-sm-table-cell">
                          Гүйлгээний утга
                        </th>
                        <th class="tx-center">Тоо хэмжээ</th>
                        <th class="tx-right">Нэгжийн үнэ</th>
                        <th class="tx-right">Нийт үнэ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="tx-nowrap">1</td>
                        <td class="d-none d-sm-table-cell tx-color-03">
                          {{ $store.state.user.userInfo.register }}
                        </td>
                        <td class="tx-center">1</td>
                        <td class="tx-right">
                          {{
                            invoice.obj.task.budget | formatMoney(0, ".", ",")
                          }}
                          ₮
                        </td>
                        <td class="tx-right">
                          {{
                            invoice.obj.task.budget | formatMoney(0, ".", ",")
                          }}
                          ₮
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row justify-content-between">
                  <div
                    class="order-2  col-sm-6 col-lg-6 order-sm-0 mg-t-40 mg-sm-t-0"
                  >
                    <label
                      class=" tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
                      >Анхаарах:</label
                    >
                    <p class="alert alert-warning">
                      ТА ТУС НЭХЭМЖЛЭЛЭЭР ТӨЛБӨР ТӨЛЖ БАЙГАА ТОХИОЛДОЛД
                      ГҮЙЛГЭЭНИЙ УТГА ХЭСЭГТ ӨӨРИЙН РЕГИСТРИЙН ДУГААРЫГ БИЧНЭ
                      ҮҮ.
                    </p>
                    <p class="alert alert-info">
                      Таны гүйлгээ 16:00 цагаас өмнө хийгдсэн тохиолдолд тухайн
                      өдөртөө, түүнээс хойш хийгдсэн тохиолдолд маргааш өдрийн
                      16:00 цаг хүртэл хугацаанд баталгаажиж, системийн эрх
                      нээгдэх болно.
                    </p>
                  </div>
                  <!-- col -->
                  <div class="order-1 col-sm-6 col-lg-4 order-sm-0">
                    <ul class="list-unstyled lh-7 pd-r-10">
                      <!-- <li class="d-flex justify-content-between">
                <span>Sub-Total</span>
                <span>$5,750.00</span>
              </li>
              <li class="d-flex justify-content-between">
                <span>Tax (5%)</span>
                <span>$287.50</span>
              </li>
              <li class="d-flex justify-content-between">
                <span>Discount</span>
                <span>-$50.00</span>
              </li> -->
                      <li class="d-flex justify-content-between">
                        <strong>Нийт төлөх дүн</strong>
                        <strong
                          >{{
                            invoice.obj.task.budget | formatMoney(0, ".", ",")
                          }}
                          ₮</strong
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
            <template>
              <div
                v-if="filePreview.show && !$store.state.app.isMobile"
                id="myContent"
              >
                <!-- <iframe
                  :src="filePreview.link"
                  style="width: 100%; height: 68vh !important"
                /> -->
                <div
                  style="width: 100%; height: 75vh !important; overflow-y: scroll"
                >
                  <img
                    style="width: 100%;"
                    :src="`${filePreview.link}?format=png&w=1200`"
                  />
                </div>
              </div>
            </template>

            <!-- <file-preview
          :id.sync="filePreview.id"
          v-if="filePreview.show"
          :force="true"
          :minusHeight="150"
              />-->
          </div>
          <div
            v-if="
              payCur.key != undefined && payCur.key == 'paymentQpay' && qPay.rdy
            "
            class="text-center bg-white pd-t-20"
          >
            <h4 class="text-center">QR код уншуулах</h4>
            <div v-if="!this.$store.state.app.isMobile">
              <img :src="`data:image/jpeg;base64,${qPay.obj.qPay_QRimage}`" />
            </div>
            <div v-else>
              <img
                :src="`data:image/jpeg;base64,${qPay.obj.qPay_QRimage}`"
                style="width: 50%"
              />
              <p>
                Та өөрийн
                <span class="font-weight-bold"
                  >смарт банкны програмыг ашиглан </span
                >төлбөрөө төлөх боломжтой.
              </p>
              <ul>
                <li
                  class="list-group-item d-flex align-items-center"
                  v-for="(d, di) in qPay.obj.qPay_deeplink"
                  :key="di"
                >
                  <template v-if="userAgentIOS">
                    <a @click="wopen(d.link)" target="_blank">
                      <img
                        :src="d.logo"
                        class="wd-30 rounded-circle mg-r-15"
                        alt=""
                      />
                    </a>
                    <a @click="wopen(d.link)" target="_blank">
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                        {{ d.name }}
                      </h6>
                    </a>
                  </template>
                  <template v-else>
                    <a :href="`${d.link}`" target="_blank">
                      <img
                        :src="d.logo"
                        class="wd-30 rounded-circle mg-r-15"
                        alt=""
                      />
                    </a>
                    <a :href="`${d.link}`" target="_blank">
                      <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                        {{ d.name }}
                      </h6>
                    </a>
                  </template>
                </li>
              </ul>
            </div>
            <div class="pd-20">
              <p>
                Төлбөр төлөгдсөний дараа таны хүсэлт баталгаажихыг анхаарна уу!.
                Та өөрийн
                <span class="font-weight-bold"
                  >смарт банкны програмыг ашиглан QR кодоор</span
                >төлбөрөө төлөх боломжтой.
              </p>
              <div class="text-center">
                Төлбөр төлсний дараа төлбөр шалгах товчийг дарж хүсэлтээ
                баталгаажуулна уу.
              </div>
            </div>
          </div>
          <div class="btn-group wd-100p">
            <button v-show="!$store.state.app.isMobile" @click="payCur = null" class="btn btn-warning">
              Буцах
            </button>
            <!-- <button
                v-if="payCur.key!=undefined && payCur.key=='paymentInvoice'"
                @click="CheckInvoice(1)"
                class="btn btn-primary"
              >Төлбөр шалгах</button>-->
            <button
              v-if="payCur.key != undefined && payCur.key == 'paymentQpay'"
              @click="checkQpay(0)"
              class="btn btn-primary"
            >
              Төлбөр шалгах
            </button>
          </div>
        </div>
        <!-- </vue-custom-scrollbar> -->
      </div>
      <div :class="`${isFullRow?'col-sm-12 mg-t-40 mg-lg-t-0':'col-sm-12 col-md-4 mg-t-40 mg-lg-t-0'}`" v-if="invoice.rdy">
        <b-modal
          title="Нэхэмжлэхийн мэдээлэл засварлах"
          v-model="invoiceEditModal"
          no-close-on-backdrop
          scrollable
        >
          <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
            <div>Байгууллага/Хувь хүн</div>
            <!-- <div class="mg-l-auto">{{invoice.obj.task.i3==1?'Байгууллага':'Хувь хүн'}} -->

            <div class="row no-gutters">
              <Radio v-model="invoice.obj.task.i3" :label="1"
                >Байгууллага</Radio
              >
              <Radio v-model="invoice.obj.task.i3" :label="2">Хувь хүн</Radio>
            </div>
          </div>
          <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
            <div>Регистр</div>
            <div class="mg-l-auto">
              <input v-model="invoice.obj.task.st2" class="form-control" />
            </div>
          </div>
          <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
            <div>Төлөгч</div>
            <div class="mg-l-auto">
              <input v-model="invoice.obj.task.task" class="form-control" />
            </div>
          </div>
          <template #modal-footer>
            <div class="mg-l-auto btn-group">
              <button
                @click="updateInvoiceInfo()"
                type="button"
                class="btn btn-success btn-xs btn-uppercase"
              >
                засах
              </button>
            </div>
          </template>
        </b-modal>
        <!-- <vue-custom-scrollbar :style="`height: ${scrollHeight.right}; position: relative;`"> -->
        <div v-if="invoice.rdy && invoice.obj.product != null">
          <h6 class="tx-13 tx-spacing-1 tx-uppercase tx-semibold mg-b-0">
            Төлбөрийн мэдээлэл
          </h6>
          <div class="row">
            <div class="col-12">
              <div class="bg-white rounded wd-100p bd bd-2 bd-light pd-2-f">
                <div class="pd-10">
                  <div class="d-flex">
                    <div class="mg-r-10">
                      <feather
                        class="wd-40-f ht-40-f"
                        type="credit-card"
                      ></feather>
                    </div>
                    <div>
                      <h6>{{ invoice.obj.product.task }}</h6>
                    </div>
                    <div
                      v-if="invoice.obj.isPayed == false"
                      class="d-flex align-items-center wd-100p"
                    >
                      <div class="mg-l-auto">
                        <button
                          @click="showInvoiceEditModal()"
                          class="btn btn-xs btn-success"
                        >
                          засах
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-light pd-10">
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Байгууллага/Хувь хүн</div>
                    <div class="mg-l-auto">
                      {{
                        invoice.obj.task.i3 == 1 ? "Байгууллага" : "Хувь хүн"
                      }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Төлөгч</div>
                    <div class="mg-l-auto">{{ invoice.obj.task.task }}</div>
                  </div>
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Регистр</div>
                    <div class="mg-l-auto">{{ invoice.obj.task.st2 }}</div>
                  </div>
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Огноо</div>
                    <div class="mg-l-auto">
                      {{ invoice.obj.task.createdDate | moment("YYYY.MM.DD") }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Банкны нэр</div>
                    <div class="mg-l-auto">
                      {{invoice.obj.task.bankName}}
                    </div>
                  </div>
                  <div class="d-flex align-items-center bd-b pd-b-10 mg-b-10">
                    <div>Дансны дугаар</div>
                    <div class="mg-l-auto">
                       {{invoice.obj.task.accountNo}}
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <div>Төлөх дүн</div>
                    <div class="mg-l-auto">
                      <h4
                        class=" tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                      >
                        {{ invoice.obj.task.budget | formatMoney(0, ".", ",") }}
                        ₮
                      </h4>
                    </div>
                  </div>
                  

                </div>
              </div>

              <div class="bg-white mg-t-20 pd-10">
                <div
                  @click="showCouponModal()"
                  class="rounded pd-10"
                  style="background-color: rgb(255, 243, 223)"
                  role="button"
                >
                  <div class="d-flex align-items-center">
                    <div class="rounded bg-warning pd-5">
                      <feather type="shopping-bag"></feather>
                    </div>
                    <div class="pd-l-10">Ваучер хөнгөлөлт ашиглах</div>
                    <div class="mg-l-auto">
                      <feather type="chevron-right"></feather>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="$store.state.user.userInfo.groupId == 9265"
            class="alert alert-info mg-b-0 mg-t-10"
            role="alert"
          >
            <h6 class="alert-heading">Санамж !</h6>
            <p class="mg-b-0-f">
              Та төлбөр шилжүүлэхдээ гүйлгээний утга дээр дараах 6 оронтой тоог
              заавал бичнэ үү. <br />
              Гүйлгээний утга: <b>{{ invoice.obj.task.total }}</b>
            </p>
          </div>

          <div
            v-if="
              invoice.obj.product.s1 != null && invoice.obj.product.s1 != ''
            "
            class="alert alert-warning mg-b-0 mg-t-10"
            role="alert"
          >
            <h6 class="alert-heading">Санамж !</h6>
            <p class="mg-b-0-f">{{ invoice.obj.product.s1 }}</p>
          </div>

          <div class="mg-t-20"
            v-if="filePreview.show && $store.state.app.isMobile"
            id="myContent"
          >
            <!-- <iframe
                  :src="filePreview.link"
                  style="width: 100%; height: 68vh !important"
                /> -->
            <div
              style="width: 100% !important; overflow-y: scroll" class="text-center"
            >
              
              <img
                style="width: 100%;"
                :src="`${filePreview.link}?format=png&w=1200`"
              />
              <a
                :href="filePreview.link" target="_blank"
                type="button"
                class="btn btn-success btn-xs btn-uppercase mg-t-5"
              >
                татах
              </a>
            </div>
          </div>
        </div>
        <!-- </vue-custom-scrollbar> -->
      </div>
    </div>

    <b-modal
      @ok="useCoupon()"
      v-model="couponObj.modal"
      title="Ваучер хөнгөлөлт ашиглах"
      centered
      cancel-title="Болих"
      ok-title="Ашиглах"
    >
      <input
        v-model="couponObj.code"
        placeholder="Ваучерийн кодоо оруулна уу"
        class="form-control"
      />
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { Notification, Radio } from "element-ui";

import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
  components: {
    vueCustomScrollbar,
    Notification,
    Radio,
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    isFullRow: {
      type: Boolean,
      default: () => false,
    },
    invoiceId: {
      type: Number,
      default: () => 0,
    },
    autoHeight: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      userAgent: null,
      userAgentIOS: false,
      payAutoBilled: false,
      payMethods: [],
      payAll: [
        {
          key: "paymentInvoice",
          logo: "card.png",
          info: "Данс дугаарар",
          desc:
            "Төлбөрийг дансанд шилжүүлэх. Интернет банк, мобайл банк, QR код, дансаар төлбөр төлөх.",
        },
        {
          key: "paymentQpay",
          logo: "qpay-small.png",
          info: "Бүх банкны qPay",
          desc:
            "Төлбөрийг дансанд шилжүүлэх. Интернет банк, мобайл банк, QR код, дансаар төлбөр төлөх.",
        },
      ],
      payCur: null,
      filePreview: {
        show: false,
        id: 0,
        link: "",
      },
      qPay: {
        rdy: false,
        obj: {},
      },
      paymentCheckCount: 0,
      invoice: {
        rdy: false,
        obj: {},
        isHtml: false,
      },
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0,
      },
      invoiceEditModal: false,
      couponObj: {
        modal: false,
        code: "",
      },
    };
  },
  watch:{
    'invoice.obj.task.i3': {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (newVal !== oldVal && oldVal != undefined) {
          // console.log(newVal, oldVal);
          this.onInvoiceTypeChange(newVal);
        }
      },
      immediate: false
    },
    'invoice.obj.task.st2': {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
        if (newVal !== oldVal) {
          this.onInvoiceSt2Change(newVal);
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.initSettings();
    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();

    this.userAgent = window.navigator.userAgent;
    //console.log("userAgent", this.userAgent);
    if (this.userAgent.match(/iPad/i) || this.userAgent.match(/iPhone/i)) {
      this.userAgentIOS = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");

    this.paymentCheckCount = 61;
  },
  methods: {
    onInvoiceTypeChange(newVal) {
      if (newVal === 1) {
        // Organization type selected
        this.invoice.obj.task.task = '';
        this.invoice.obj.task.st2 = '';
      } else if (newVal === 2) {
        // console.log('Individual type selected', this.$store.state.user.userInfo.fullName);
        // Individual type selected
        this.invoice.obj.task.task = this.$store.state.user.userInfo.fullName;
        this.invoice.obj.task.st2 = this.$store.state.user.userInfo.register;
      }
    },
    onInvoiceSt2Change(newVal) {
      // Check if i3 is 1 and st2 has more than 3 characters
      if (this.invoice.obj.task.i3 === 1 && newVal && newVal.length > 3) {
        this.onOrganizationRegisterChange(newVal);
      }
    },
    onOrganizationRegisterChange(registerValue) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "CRM/GetOrganizationNameByRegister" },
        params: { regNo: registerValue },
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res != false && res?.data?.found===true){
          // console.log(res);
          this.invoice.obj.task.task = res.data.name;
        }else{
          this.invoice.obj.task.task = '';
        }
      });
    },
    replacePdfWithPdfjs() {
      var contentDiv = document.getElementById("myContent");
      var iframes = contentDiv.getElementsByTagName("iframe");

      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];
        var src = iframe.getAttribute("src");

        // Check if the iframe source contains '.pdf'
        if (src && src.includes(".pdf")) {
          // Replace the PDF URL with the PDF.js viewer URL
          var pdfjsUrl =
            "https://mozilla.github.io/pdf.js/web/viewer.html?file=" +
            encodeURIComponent(src);
          iframe.setAttribute("src", pdfjsUrl);
        }
      }
    },
    copy() {
      //console.log('copied')
      this.$refs.accno.focus();
      var successful = document.execCommand("copy");
      if (successful) {
        Notification.success({
          message: "Дансны дугаар амжилттай хуулагдлаа.",
          duration: 3000,
          type: "success",
          position: "top-right",
          offset: 50,
        });
      }

      //console.log(successful)
      //clipboard.writeText('343100195073');
      //document.execCommand('copy');
    },
    useCoupon() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/CheckCoupon" },
        data: { invoiceId: this.invoiceId, couponCode: this.couponObj.code },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('res');
        if (res != false) {
          this.initSettings();
        }
      });
    },
    showCouponModal() {
      this.couponObj.modal = true;
    },
    showInvoiceEditModal() {
      this.invoiceEditModal = true;
    },
    updateInvoiceInfo() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "post", url: "Payment/updateInvoiceInfo" },
        data: {
          id: this.invoiceId,
          i3: this.invoice.obj.task.i3,
          task: this.invoice.obj.task.task,
          st2: this.invoice.obj.task.st2,
        },
        store: this.$store,
      }).then((res) => {
        //this.toggleBodyClass('removeClass', 'dynamic-locker');
        if (res != false) {
          this.invoiceEditModal = false;
        }
        this.toggleBodyClass("removeClass", "dynamic-locker");
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    initSettings() {
      let self = this;
      //this.toggleBodyClass('addClass', 'dynamic-locker');
      request({
        api: { method: "GET", url: "Payment/GetInvoiceDetail" },
        params: { id: this.invoiceId },
        store: this.$store,
      }).then((res) => {
        //this.toggleBodyClass('removeClass', 'dynamic-locker');
        if (res != false) {
          //console.log("GetInvoiceDetail=> ", res);
          this.invoice.rdy = true;
          this.invoice.obj = res.data.invoice;
          if (res.data.invoice.isPayed) {
            this.payAutoBilled = true;
            this.$emit("on-pay-success", this.invoice.obj);
          }
        }
      });

      request({
        api: { method: "GET", url: "Payment/Settings" },
        //params: { id: this.$route.params.id },
        store: this.$store,
      }).then((res) => {
        //this.toggleBodyClass('removeClass', 'dynamic-locker');
        if (res != false) {
          this.payMethods = res.data.settings
            .filter((x) => x.value == 1)
            .map((s) => {
              return Object.assign(
                s,
                self.payAll.filter((z) => z.key == s.key)[0]
              );
            });
          //console.log(this.payMethods);
          if (this.payMethods.length == 1) {
            this.choosePayment(this.payMethods[0]);
          }
          //console.log("Settings=> ", this.payMethods);
        }
      });
    },
    choosePayment(p) {
      this.payCur = p;
      this.filePreview.show = false;
      this.qPay.rdy = false;
      if (p.key == "paymentInvoice") {
        if (
          this.$store.state.app.activeGroup.id == 9235 || 
          this.$store.state.app.activeGroup.id == 9362 ||
          this.$store.state.app.activeGroup.id == 9368 ||
          this.$store.state.app.activeGroup.id == 9351 || 
          this.$store.state.app.activeGroup.id == 9363 ||
          this.$store.state.app.activeGroup.id == 9290
        ) {
          //console.log(this.invoice.obj);
          this.invoice.isHtml = true;
        } else {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "Payment/createPDFInvoice" },
            data: { invoiceId: this.invoiceId },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log(res);
              this.filePreview.id = res.data.file.id;
              this.filePreview.link = res.data.file.link;
              this.$nextTick(() => {
                this.filePreview.show = true;

                // this.$nextTick(()=>{
                //   this.replacePdfWithPdfjs();
                // });

                this.paymentChecker();
              });
            }
          });
        }
      } else if (p.key == "paymentQpay") {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "qPay/GetSimpleInvoice" },
          params: { invoiceId: this.invoiceId },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.qPay.obj = res.data.json_data;
            this.qPay.rdy = true;

            this.paymentChecker();
          }
        });
      }
    },
    paymentChecker() {
      let self = this;
      //console.log("paymentChecker frd", this.paymentCheckCount, self.payCur);

      if (this.paymentCheckCount == 0) {
        this.$emit("on-invoice-created");
      }

      if (this.paymentCheckCount < 60) {
        setTimeout(function() {
          if (
            self.payCur != null &&
            self.payCur.key != undefined &&
            self.payCur.key == "paymentQpay"
          ) {
            self.checkQpay(1);
          }
          // else if(self.lendQr.show){
          //     //console.log("checker loaded lend");
          //     self.checkLend(1);
          // }
          else if (
            self.payCur.key != undefined &&
            self.payCur.key == "paymentInvoice"
          ) {
            self.checkBankResponse(1);
          }
        }, 10000);
      }
      this.paymentCheckCount++;
    },
    checkQpay(type) {
      //console.log('checkQpay', type);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "qpay/CheckInvoice" },
        data: { invoiceId: this.invoiceId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res.result == 1) {
          //console.log(res);
          Notification.success({
            message: "Төлбөр хийгдсэн байна.",
            duration: 3000,
            type: "success",
            position: "top-right",
            offset: 50,
          });

          if (res.hasRawLink != undefined && res.hasRawLink) {
            this.$router.push(res.rawLink);
          } else {
            this.$emit("on-pay-success", this.invoice.obj);
          }
        } else {
          if (type != 1) {
            Notification.warning({
              message: "Төлбөр хийгдээгүй байна.",
              duration: 3000,
              type: "warning",
              position: "top-right",
              offset: 50,
            });
          } else {
            this.paymentChecker();
          }
        }
      });
    },
    checkBankResponse(type) {},
    getWindowHeight() {
      let contentSub = 120;
      let navSub = 120;
      let rightSub = 120;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      if (this.autoHeight) {
        this.scrollHeight.content = "auto";
        this.scrollHeight.right = "auto";
      } else {
        this.scrollHeight.content = window.innerHeight - contentSub + "px";
        this.scrollHeight.right = window.innerHeight - rightSub + "px";
      }
      //console.log('this.autoHeight', this.autoHeight, this.scrollHeight.content, this.scrollHeight.right);
      this.scrollHeight.nav = window.innerHeight - navSub;
    },
    wopen(link) {
      //alert("1");
      var encoded = encodeURIComponent(link);
      window.open(`https://link.onoo.mn?l=${encoded}`, "_blank");
      //window.open(`${link}`);
    },
  },
};
</script>

<style></style>
